import { render, staticRenderFns } from "./OAuthItem.vue?vue&type=template&id=37fc5718&scoped=true"
import script from "./OAuthItem.vue?vue&type=script&lang=js"
export * from "./OAuthItem.vue?vue&type=script&lang=js"
import style0 from "./OAuthItem.vue?vue&type=style&index=0&id=37fc5718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc5718",
  null
  
)

export default component.exports